import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api.service';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class WorkflowRunService {

  /****************** Variable declaration ******************/
  public repoSubject = new Subject<any>();
  data$ = this.repoSubject.asObservable();
  repo: any = []
  activeCard: any;

  public wfType: string;

  /* Define required urls */
  public wfRunApis = this.apiService.WF_RUN_APIS;
  public wfRunUrl = this.apiService.KPID_URL + this.wfRunApis.WF_RUN;

  /**
   * Constructor
   * @param httpClient 
   * @param apiService 
   */
  constructor(private httpClient: HttpClient,
    private apiService: ApiService) { }

  /**
   * Retrieves the workflow jobs
   * @param duration 
   * @param wkflId 
   * @param offset 
   * @param size 
   * @returns 
   */
  getWfRun(duration: number, wkflId: number, offset?: number, size?: number) {
    return this.httpClient.get(this.wfRunUrl + this.wfRunApis.WF_RUN_BY_ID(duration, wkflId, offset, size))
  }

  /**
   * Retrieves the workflow job stages
   * @param gnChart 
   * @param jobId 
   * @returns 
   */
  getWfJobDet(gnChart: boolean, jobId: string) {
    return this.httpClient.get(this.wfRunUrl + this.wfRunApis.WF_RUN_BY_JOB_ID(gnChart, jobId))
  }

  /**repo list */
  repoList(repoArr: any) {
    this.repo = repoArr
    this.repoSubject.next(this.repo)
  }

  /** assign active card data to the variable */
  activeCardDet(data: any) {
    this.activeCard = data;
  }
}
